import React, { useState, useEffect } from "react";

import "./Healthtips.css"
const MensesApp = () => {
  const [data, setData] = useState([]);
  const [front, setFront] = useState(true);
  const [currentQuote, setCurrentQuote] = useState({ text: "", tip: "" });

  useEffect(() => {
    fetch("/card.json")
      .then((response) => response.json())
      .then((fetchedData) => {
        setData(fetchedData);
        setCurrentQuote(fetchedData[0]); // Initialize with the first quote
      });
  }, []);

  const displayQuote = () => {
    if (data.length === 0) return;

    const index = Math.floor(Math.random() * data.length);
    setCurrentQuote(data[index]);
    setFront(!front);
  };

  return (
    <div>
      {/* Header */}
      <header id="header" className="d-flex align-items-center">
        <div className="container d-flex align-items-center justify-content-between">
          <h1 className="logo"><a href="index.html">Menses</a></h1>
          <nav id="navbar" className="navbar">
            <ul>
              <li>
                <a className="nav-link scrollto active" href="main.html">
                  <i className="bi bi-house-door"></i> Home
                </a>
              </li>
            </ul>
            <i className="bi bi-list mobile-nav-toggle"></i>
          </nav>
        </div>
      </header>

      {/* Quick Health Tips Section */}
      <section id="cards">
        <div>
          <h2 className="top">Quick health tips!</h2>
          <div className="block text-center">
            <div className={`quote-box block__main block__front ${front ? "visible" : "hidden"}`}>
              <span className="quote">
                <span className="text">{currentQuote.text}</span>
              </span>
              <div className="title">{currentQuote.tip}</div>
              <button className="new-quote btn btn-default" onClick={displayQuote}>
                New Tip!
              </button>
            </div>

            <div className={`quote-box block__main block__back ${!front ? "visible" : "hidden"}`}>
              <span className="quote">
                <span className="text">{currentQuote.text}</span>
              </span>
              <div className="title">{currentQuote.tip}</div>
              <button className="new-quote btn btn-default" onClick={displayQuote}>
                New Tip!
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Alan Button Script */}
      <div id="alan-btn"></div>
      <script
        type="text/javascript"
        src="https://studio.alan.app/web/lib/alan_lib.min.js"
      ></script>
    </div>
  );
};

export default MensesApp;


